











































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import {
  Registration as IRegistration,
  RegistrationEditStatusEnum
} from "@/api-v2/course/models";
import TableActions from "@/components/form/TableActions.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { courseApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { isAllowEditDates } from "@/plugins/modules-detect";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import moment from "moment";
import { getCurrentCompanyId, isRoot } from "@/plugins/roles";
import Modal from "@/components/form/Modal.vue";
import UserStudentFiles from "@/components/user/UserStudentFiles.vue";

@Component({
  components: {
    UserStudentFiles,
    Modal,
    CustomDatepicker,
    CustomButton,
    TableActions,
    CustomTableCol,
    CustomTableItem,
    CustomTable
  }
})
export default class CourseRegistrationsTableItem extends Vue {
  @Prop() registration!: IRegistration;
  @Prop() isLoading!: boolean;
  @Prop() isShowAction!: boolean;
  @Prop() checked!: boolean;
  isCheck: boolean = false;
  isStatusChanging: boolean = false;
  status!: string;
  isRemoving: boolean = false;
  isEditDateShow: boolean = false;
  isShowEditDateSpinner: boolean = false;
  startedAtDate: Date | string = moment(this.registration?.startedAt).format(
    "YYYY-MM-DD"
  );
  startedAtTime: Date | string = moment(this.registration?.startedAt).format(
    "hh:mm"
  );

  data() {
    return {
      status: undefined
    };
  }

  get fullName() {
    return this.registration.student
      ? `${this.registration.student.lastName} ${
          this.registration.student.firstName
        } ${
          this.registration.student.middleName
            ? this.registration.student.middleName
            : ""
        }`
      : "";
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get userIsCanEditStartedDate() {
    return (
      (this.companyId === this.registration?.course?.companyId || this.root) &&
      (this.registration.status === "learning" ||
        this.registration.status === "pause")
    );
  }

  get isCanEditDateModule() {
    return isAllowEditDates();
  }

  get statuses() {
    return RegistrationEditStatusEnum;
  }

  get startedAt() {
    return {
      date: this.startedAtDate,
      time: this.startedAtTime,
      dateTimeString: `${this.startedAtDate} ${this.startedAtTime}`,
      formed: new Date(
        moment(`${this.startedAtDate} ${this.startedAtTime}`).format()
      )
    };
  }

  async changeStartedAtDate() {
    try {
      this.isShowEditDateSpinner = true;
      const { data } = await courseApi.CourseRegistration.changeLearningDate(
        this.registration.id,
        {
          startedAt: this.startedAt.formed,
          finishedAt: undefined,
          status: this.status as any
        }
      );
      this.registration.startedAt = data.startedAt;
      this.initDate();
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isShowEditDateSpinner = false;
      this.isEditDateShow = false;
    }
  }

  changeCheckBox() {
    this.$emit("check", this.registration);
  }

  initDate() {
    this.startedAtDate = moment(this.registration?.startedAt).format(
      "YYYY-MM-DD"
    );
    this.startedAtTime = moment(this.registration?.startedAt).format("hh:mm");
  }

  statusFormatter(status: string) {
    if (status === "learning") return `${this.$tc(this.$translate.Learning)}`;
    if (status === "pause") return `${this.$tc(this.$translate.Pause)}`;
    if (status === "success") return `${this.$tc(this.$translate.Success)}`;
    if (status === "fail") return `${this.$tc(this.$translate.NotComplete)}`;
    if (status === "abort") return `${this.$tc(this.$translate.Canceled)}`;
    return status;
  }

  changeStatus() {
    this.isStatusChanging = true;
    courseApi.CourseRegistration.editCourseRegistration(this.registration.id, {
      status: this.status as RegistrationEditStatusEnum
    })
      .then(res => {
        this.$emit("edit", res.data);
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isStatusChanging = false;
      });
  }

  @Watch("checked")
  checkChecked() {
    this.isCheck = this.checked;
  }

  created() {
    this.status = this.registration.status;
  }
}
